// export const API_URL = "https://rwoodapipy.znapay.in/";

export const API_URL = "https://rwoodapipy.znapay.in/";


// export const API_URL = "http://localhost:5000/";